// src/pages/ChatPage.jsx
import React from 'react';
import ChatBox from '../components/ChatBox';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ChatPage() {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 flex flex-col">
      {/* هدر */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-4 flex justify-between items-center shrink-0 shadow-lg z-10">
        <h3 className="font-bold text-lg">پشتیبانی آنلاین</  h3>
        <button
          onClick={() => navigate(-1)}
          className="text-white hover:bg-white/20 p-2 rounded-full transition-all active:scale-95"
        >
          <ArrowRight className="w-6 h-6" />
        </button>
      </div>

      {/* چت‌باکس — تمام فضای باقی‌مانده */}
      <div className="flex-1 flex flex-col min-h-0">
        <ChatBox onClose={() => navigate(-1)} />
      </div>
    </div>
  );
}